import _ from 'lodash';
import CommonUtil from '../../../common/CommonUtil';
import {
  Mode, Market, BetTypeGroup, OddsMode, FullEvent,
  EventDetail, OutrightEventMap, SpecialEventMap,
  CorrectScoreTypes, ContestantLineMap, E_SPORT_ID,
  EventOrder, SPORTS_ICON, TeaserType, TeaserSports, TENNIS_COUNT_MORE_BET,
  DEFAULT_DATES, MARKET_TABS, MINUTES_PERIODS, PERIODS_MAIN_ODDS,
  PERIODS_RIGHT_ODDS_LAYOUT, PERIODS_MAIN_LABEL, HOME_AWAY_LABEL, GRADING_UNIT_TYPE,
  PERIOD_STATUS, MESSAGES_ODD_PAGE_WS, DESTINATION_WS, standardizeEventParamsMap, ODDS_CONTAINER_TYPE
} from '../../../common/Foundation';
import doTUtils from '../../../common/doTUtils';
import $ from 'jquery';
import moment from 'moment';
import OddsDataAdapter from '../../../common/OddsDataAdapter';
import { eventMap } from './constants';
import Constants from '../../../common/Constants';

const EMPTY_VALUE = '';
export default class OddsPageUtils {

    static getLeagueIds(options) {
      const {
        mode, leagueIds, eSports, outright, sportId
      } = options;

      let ids = [];
      if (sportId == E_SPORT_ID) {
        ids = eSports.eSportLeagueIds;
      } else if (this.isOutright(mode)) {
        ids = outright.leagueIds;
      } else {
        ids = leagueIds;
      }
      return _.join(ids, ',');
    }

    static getSelectedDate(marketTab, options){
      let date = "";
        if(marketTab === MARKET_TABS.EARLY){
          date = options.filterOptions.selectedDate;
        }else if(options.sportId !== E_SPORT_ID && marketTab === MARKET_TABS.TODAY && options.mode === Mode.PARLAY_MARKET){
          date = moment().locale('en').utcOffset("GMT-04:00").format("YYYY-MM-DD");
        }
        return date;
    }

    static getParams(market, options, isAuth, moreBetId, isShowHighlight = true, marketTab = '', pimoEvent = '', useWebSocket = false) {
      let _version = CommonUtil.getCacheVersion();
      return this.standardizeEventsParams({
        mk: market,
        sp: options.sportId,
        ot: options.oddsFormat,
        btg: this.getBetTypeGroup(options),
        o: options.order,
        lg: this.getLeagueIds(options),
        ev: "",
        d: this.getSelectedDate(marketTab, options),
        l: options.marketFilter > 0 ? options.marketFilter : 5,
        v: useWebSocket ? "" : _version[market === Market.Live ? 0 : 1],
        me: moreBetId ? moreBetId : 0,
        more: false,
        c: options.country || '',
        tm: this.getMarket(options) === Market.Today ? options.timeFilter : 0,
        g: options.ogCache,
        pa: options.mode === Mode.PARLAY_MARKET || options.mode === Mode.PARLAY ? 1 : 0,
        pn: CommonUtil.getPeriodNumParam(options.period),
        cl: options.marketFilter > 0 ? options.marketFilter : 5,
        _g: isAuth ? 0 : 1,
        wm: '',
        ec: this.getESportGameCode(options),
        lv: '',
        pimo: pimoEvent || '',
        hle: isShowHighlight && marketTab === MARKET_TABS.EARLY,
        inl: options.sportId === Constants.TENNIS_ID && window.env.isUseNewTennisLayout, //isNewLayout
        pv: 1
      });
    }

    static getEventFavouriteParams(market, options, isAuth, moreBetId, leagueIdUrl, marketTab = '', pimo = '') {
      const _version = CommonUtil.getCacheVersion();
      let favouriteEventId = _.get(options, 'favouriteEventId', '');
      if(favouriteEventId && favouriteEventId.toString().split(',')) {
        const fetchEventId = favouriteEventId.toString().split(',') || [];
        favouriteEventId = fetchEventId && fetchEventId.length > 0 ? [...new Set(fetchEventId)].join(',') : '';
      }
      const favoriteLeagueId = _.get(options, 'favouriteLeagueId', '');
      const topLeagueId = _.get(options, 'topLeagueLeagueId', '');
      const leagues = options.favourite && favoriteLeagueId ? favoriteLeagueId : leagueIdUrl ? leagueIdUrl : (options.isTopLeague && topLeagueId ? topLeagueId : this.getLeagueIds(options))
      const btg = OddsPageUtils.isLeagueIdUrlExisted(leagueIdUrl) ? BetTypeGroup.HDP_OU : this.getBetTypeGroup(options);
      var params = {
          mk: Market.ALL,
          sp: options.sportId,
          ot: options.oddsFormat,
          btg: btg,
          o: options.order,
          lg: leagues,
          ev: options.favourite && favouriteEventId ? favouriteEventId : "",
          d: this.getSelectedDate(marketTab, options),
          l: options.marketFilter > 0 ? options.marketFilter : 5,
          v: _version[1], // version of no live event 
          me: moreBetId ? moreBetId : 0,
          more: false,
          c: options.country || '',
          tm: this.getMarket(options) === Market.Today ? options.timeFilter : 0,
          g: options.ogCache,
          pa: options.mode === Mode.PARLAY_MARKET || options.mode === Mode.PARLAY ? 1 : 0,
          pn: options.period > 0 ? options.period : -1,
          cl: options.marketFilter > 0 ? options.marketFilter : 5,
          _g: isAuth ? 0 : 1,
          wm: '',
          ec: this.getESportGameCode(options), 
          lv: market === Market.Live ? _version[0]: '', // version of live event
          pimo: pimo || this.getPimoParam(options.sportId, btg, options.period, options.oddsMode),
          hle: false
      }
      return params;
  }

    static getESportGameCode(options) {
        return options.eSports.eSportCode;
    }

    /**
     * build more bet params
     */
    static getMorebetParams(options, morebetId, isAuth, pimoEvent = '') {
      const btg = this.getBetTypeGroup(options);
      let cl = options.marketFilter > 0 ? options.marketFilter : 5;
      const pimoParam = options.sportId !== Constants.ESPORT_ID ? pimoEvent : '';
      if (btg == BetTypeGroup.ML_1X2 || btg == BetTypeGroup.TEAM_TOTAL) {
        cl = 0;
      }
      return this.standardizeEventsParams({
        mk: Market.ALL,
        ot: options.oddsFormat,
        btg: btg,
        v: 0,
        me: morebetId,
        more: true,
        c: options.country,
        g: options.ogCache,
        pa: options.mode === Mode.PARLAY || options.mode === Mode.PARLAY_MARKET ? 1 : 0,
        cl: cl,
        pn: options.period > 0 ? options.period : -1,
        pimo: parseInt(options.period) > 0 ? this.getPimoParam(options.sportId, btg, options.period, options.oddsMode) : pimoParam,
        _g: isAuth ? 0 : 1,
        pv: 1
      });
    }

    static getPimoParam(sportId, betTypeGroup, period, oddsMode) {
      const isDoubleLine = oddsMode === OddsMode.Double;
      const usePimo = (parseInt(betTypeGroup, 10) === BetTypeGroup.HDP_OU && isDoubleLine) || parseInt(betTypeGroup, 10) === BetTypeGroup.ML_1X2 || (sportId === Constants.SOCCER_ID);
      if (usePimo) {
        if (parseInt(period, 10) < 1) {
          return PERIODS_MAIN_ODDS[sportId]
            ? PERIODS_MAIN_ODDS[sportId]
            : ""
        } else {
          return `${period}`
        }
      }
    }

    static getLiveCenterParams(options, event, isRefresh) {
      const version = isRefresh ? CommonUtil.getCacheVersion()[0] : 0;
      const { country, ogCache, betTypeGroup, period } = options;
      const { leagueId, eventId, sportId } = event;
      let cl = options.marketFilter > 0 ? options.marketFilter : 5;
      const btg = this.getBetTypeGroup(options);
      if (btg == BetTypeGroup.ML_1X2 || btg == BetTypeGroup.TEAM_TOTAL) {
        cl = 0;
      }
      return this.standardizeEventsParams({
        mk: Market.Live,
        sp: sportId,
        lg: leagueId,
        ev: eventId,
        ot: options.oddsFormat,
        btg: BetTypeGroup.HDP_OU,
        v: version,
        me: eventId,
        more: true,
        c: country,
        g: ogCache,
        pa: 0,
        cl: cl,
        pn: period > 0 ? period : -1,
        _g: 1,
        pv: 1
      });
    }

  static getEventStatsParams(options, isAuth, pimoEvent, event, isRefresh, useHttpRequest) {
    const version = isRefresh ? CommonUtil.getCacheVersion()[0] : 0;
    const { eventId } = event;
    return this.standardizeEventsParams({
      mk: options.market,
      sp: options.sportId,
      ot: options.oddsFormat,
      btg: this.getBetTypeGroup(options),
      o: options.order,
      lg: "",
      ev: eventId,
      d: "",
      l: options.marketFilter > 0 ? options.marketFilter : 5,
      v: useHttpRequest ? version[options.market === Market.Live ? 0 : 1] : "",
      me: eventId,
      more: false,
      c: options.country || '',
      tm: this.getMarket(options) === Market.Today ? options.timeFilter : 0,
      g: options.ogCache,
      pa: options.mode === Mode.PARLAY_MARKET || options.mode === Mode.PARLAY ? 1 : 0,
      pn: CommonUtil.getPeriodNumParam(options.period),
      cl: options.marketFilter > 0 ? options.marketFilter : 5,
      _g: isAuth ? 0 : 1,
      wm: '',
      ec: this.getESportGameCode(options),
      lv: '',
      pimo: pimoEvent || '',
      hle: false,
      inl: options.sportId === Constants.TENNIS_ID && window.env.isUseNewTennisLayout //isNewLayout
    });
  }
  
  static getLiveTVParams(options, event, isRefresh) {
    const version = isRefresh ? CommonUtil.getCacheVersion()[0] : 0;
    const { country, ogCache, betTypeGroup, period } = options;
    const { leagueId, eventId, sportId } = event;
    return this.standardizeEventsParams({
      mk: Market.Live,
      sp: sportId,
      lg: leagueId,
      ev: eventId,
      ot: options.oddsFormat,
      btg: BetTypeGroup.HDP_OU,
      v: version,
      me: eventId,
      more: true,
      c: country,
      g: ogCache,
      cl: 0,
      pn: period > 0 ? period : -1,
      pa: betTypeGroup == BetTypeGroup.MIX_PARLAY ? 1 : 0,
      _g: 1,
      pv: 1
    });
  }

    /**
     * Get bet type by mode.
     */
    static getBetTypeGroup(options) {
        if (options.mode === Mode.PARLAY || options.mode === Mode.PARLAY_MARKET) {
            return BetTypeGroup.HDP_OU;
        } else if(options.isTeaser || options.isTeaserMarket) {
            return BetTypeGroup.TEASERS;
        }
        return options.betTypeGroup;
    }

    /**
     * Get market by mode.
     */
    static getMarket(options) {
        if(options.mode === Mode.NORMAL) {
            return options.market
        }
        return Market.Today;
    }

    static bindingHtml(sports, options, isLiveEvent = false) {
        const isShowLiveTV = 
        (options.sportSuppLS > -1 && (options.sportSuppLS === 0 || options.sportSuppLS === options.sportId)) // has support
        && options.hasLiveTVEvent // has event
        && (options.isShowLiveTv || false) && window.env.checkBrandSettingLS; //has enable
        const __udata = CommonUtil.getUserData() || {};
        const blockedLiveSports = __udata.liveBlockedSports || [];
        const blockedLiveLeagues = __udata.liveBlockedLeagues || [];
        const isBlockedLiveSport = _.includes(blockedLiveSports, options.sportId);
        const isNewTennis = options.sportId === Constants.TENNIS_ID && window.env.isUseNewTennisLayout;
        let dataRender = {
            sports: sports,
            maxLines: options.marketFilter,
            singleLine: options.oddsMode === OddsMode.Single,
            ot: options.oddsFormat
        };
        dataRender.isLiveEvent =  isLiveEvent;
        dataRender.period = options.period;
        dataRender.isLive = options.isLive || false;
        dataRender.isParlay = options.mode === Mode.PARLAY || false;
        dataRender.isParlayMarket = options.mode === Mode.PARLAY_MARKET || false;
        dataRender.favourite = options.favourite || false;
        dataRender.isOnlyEsport = options.isOnlyEsport || false;
        dataRender.isShowLiveTv = isShowLiveTV;
        dataRender.esportsLogoURL = this.getEsportLogoURL();
        dataRender.isEnableSignUp =window.env.skinName === 'pa';
        dataRender.isBlockedLiveSport = isBlockedLiveSport;
        dataRender.blockedLiveLeagues = blockedLiveLeagues;
        dataRender.periodsRightLayout = PERIODS_RIGHT_ODDS_LAYOUT[options.sportId] || [1]; // default period for col2 of odds page layout is 1
        dataRender.altMainLabel = PERIODS_MAIN_LABEL[options.sportId] ? ('_' + PERIODS_MAIN_LABEL[options.sportId]) : '';
        dataRender.isBrandSupportLiveCenter = CommonUtil.isBrandSupportLiveCenter();
        dataRender.periodsDescription = options.periodsDescription;
        dataRender.favouritePeriod = options.favouritePeriod || null;
        dataRender.isNewTennis = isNewTennis;
        dataRender.homeAwayLabel = isNewTennis ? HOME_AWAY_LABEL[options.sportId] || HOME_AWAY_LABEL[0] : HOME_AWAY_LABEL[0];
        dataRender.isShowPeriodName = CommonUtil.isShowPeriodName(options.sportId);
        return doTUtils.bindData(dataRender, options);
    }

    /**
     * Get Esport logo URL based on __udata
     */
    static getEsportLogoURL() {
      if (CommonUtil.getBase64LocalStorage('__udata')) {
        let __udata = CommonUtil.getUserData();
        let esportsLogoVersion;
  
        if (__udata){
          esportsLogoVersion = __udata.esportsLogoVersion;
        }
        return _.replace(window.env.esportsLogoURL, '{version}', esportsLogoVersion);
      }
    }

    static renderOddsData(data, market, options) {
        let oddsContent = {live: '', nonlive: '', u: null};
        this.cacheVersionDataResponse(data, market);
        oddsContent.u = data.u;
        if(options.market === Market.Live) {
            oddsContent.live = this.bindingHtml(data, true, options);
        } else {
            if(_.get(data, 'l[0][2].length', 0) > 0) {
                oddsContent.live = this.bindingHtml(data, true, options);
            }
            if(_.get(data, 'l[0][2].length', 0) === 0 || _.get(data, 'n[0][2].length', 0) > 0) {
                oddsContent.nonlive = this.bindingHtml(data, false, options);
            }
        }
        return oddsContent;
    }

    /**
     * Cache version of data response 
     */
    static cacheVersionDataResponse(data, isLive) {
        let _version = CommonUtil.getCacheVersion();
        let sports = data[isLive ? 'l' : 'n'];
        if (sports && sports.length > 0) {
            _version[isLive ? 0 : 1] = CommonUtil.cacheVersionData(sports, 3);
        } else if (data.u && data.u.length > 0) {
            if(data.u.length === 1){
              _version[isLive ? 0 : 1] = CommonUtil.cacheVersionData(data.u, 2);
            }else if (data.u.length === 2) {
              _version = _.reverse(CommonUtil.cacheVersionData(data.u, 2).split(','));
            }
        }
        CommonUtil.setCacheVersion(_version);
    }

    /**
     * Cache version of data response 
     */
    static cacheVersionEventResponse(data) {
      let _version = CommonUtil.getCacheVersion();
      const sports = data['e'];
      if (sports && sports.length > 0) {
        _version[0] = sports[4] || 0;
      } else if (data.u && data.u.length > 0 && data.u[0][2] > 0) {
        _version[0] = CommonUtil.cacheVersionData(data.u, 2);
      }
      CommonUtil.setCacheVersion(_version);
  }

  static updatedOddMap = {
    PeriodNum: 0,
    BetType: 1,
    SelectionType: 2,
    homeSpread: 3,
    odd:5,
    oddsid: 6,
    isAltLine: 8,
    upDownblinking: 9
  }

    /**
     * Check odds updated
     * @param {*} market 
     */
  static checkOddsChange(oddsUpdated, market, options, _$changedOdds) {
    let isLive = market === Market.Live;
    let listOdds = oddsUpdated;
    let $odds = _$changedOdds[isLive ? 0 : 1] || [];
    for (let j = 0; j < (oddsUpdated || []).length; j++) {
      const data = listOdds[j][1];
      //ID: EventId|PeriodNum|BetType|SelectionType|isAltLine[|Handicap]
      for (let i = 0; i < data.length; i++) {
        const u = data[i];
        const action = u[u.length - 2];
        const updatedOddMap = OddsPageUtils.updatedOddMap
        switch (action) {
          case 0:
            const oid = [
              u[u.length - 1], //EventId
              u[updatedOddMap.PeriodNum], //PeriodNum
              u[updatedOddMap.BetType], //BetType
              u[updatedOddMap.SelectionType], //SelectionType
              u[updatedOddMap.isAltLine] ? 1 : 0, //isAltLine
              u[updatedOddMap.homeSpread] || 0
            ].join('|');
            const a = document.getElementById(oid);
            if (OddsPageUtils.updateOdds(u, a, options)) {
              $odds.push(a);
            }
            break;
          case 8:
            OddsPageUtils.updateEventStatus(u)
            break;
          case 9:
            OddsPageUtils.updateTimeEvent(u)
            break;
          case 10:
            OddsPageUtils.updateScore(u)
            break;
          case 13:
            OddsPageUtils.updatePeriodStatus(u, options)
            break;
          default:
            break;
        }
      }
    }
  }

  static updateTimeEvent(u) {
    if (u[0]) {
      const $time = $(document).find("#e" + u[u.length - 1] + " tr.e" + u[u.length - 1] + " td.col-time .liveTm");
      const tm = u[1]
        ? `${u[0]} ${u[1]}`
        : u[0]
      $time.text(tm);
    }
  }

  static updatePeriodStatus(u, options) {
    if (u[0]) {
      const periodNum = u[1];
      const currentStatus = PERIOD_STATUS.filter(status => status !== `status_${u[0]}`).join("");
      const e = options.sportId === 33 && options.betTypeGroup !== BetTypeGroup.TEAM_TOTAL
        ? document.querySelectorAll("tr[data-pid='" + periodNum + "'] td[data-eventid='" + u[u.length - 1] + "']")
        : document.querySelectorAll("tr.e" + u[u.length - 1] + " td[data-period ='" + periodNum + "']")
      $(e).removeClass(currentStatus).addClass("status_" + u[0]);
    }
  }

  static updateScore(u) {
    if (u[0]) {
      let $score = $(document).find("#e" + u[u.length - 1] + "_0 td.col-time span:eq(0)");
      $score.text(u[0]);
    }
  }

  static updateOdds(u, a, options) {
    if (a) {
      const {updatedOddMap} = OddsPageUtils
      const $a = $(a);
      $a.data("oddsid", u[updatedOddMap.oddsid]);
      if (u[updatedOddMap.odd] && $a.text() != u[updatedOddMap.odd] && u[updatedOddMap.upDownblinking] == 0) { /// check if odd change but u9 = 0
        u[updatedOddMap.upDownblinking] = u[updatedOddMap.odd] > $a.text() ? 1 : -1;
      }
      if (u[updatedOddMap.upDownblinking] !== 0) {
        $a.removeClass("up down blinking").removeClass("fav sm")
          .addClass(u[5] < 0 ? 'fav' : '')
          .find("span").text((!options.isParlay && options.oddsFormat === 0) ? ((u[5] > 0 ? '+' : '') + u[5]) : u[5].formatSeparators());
        if (u[10] !== 'H') {
          $a.addClass(u[9] > 0 ? "up blinking" : "down blinking");
        }
        return true
      }
    }
    return false
  }

  /**
     * Clean blinking odds for WS.
     * @param {*} live 
     */
  static cleanIndicatorWS(isRefreshAll) {
    if (isRefreshAll) {
      window.changedOddsWS = {}
      return
    }
    const currentTime = new Date().getTime()
    let oddsChange = window.changedOddsWS;
    if (_.isEmpty(oddsChange)) return
    const _oddChange = { ...window.changedOddsWS }
    const timeout = window.env.indicatorOddWSTimeout || 5000
    for (const [id, timeMessage] of Object.entries(_oddChange)) {
      if (currentTime - timeMessage > timeout) {
        const $oddELe = document.getElementById(id)
        if ($oddELe) {
          $($oddELe).removeClass("up down blinking").attr("title", "")
          delete window.changedOddsWS[id]
        }
      }
    }
  }

  static updateEventStatus(u) {
    let e = $(document).find("tr[class='e" + u[u.length - 1] + "']");
    $(e).removeClass("status_O status_I status_H").addClass("status_" + u[0]);
  }

  /**
   * Check odds updated for WS
   * @param {*} market 
   */
  static checkOddsChangeWS(oddsUpdated, options, timeMessage) {
    for (let j = 0; j < (oddsUpdated || []).length; j++) {
      const data = oddsUpdated[j][1];
      //ID: EventId|PeriodNum|BetType|SelectionType|isAltLine[|Handicap]
      for (let i = 0; i < data.length; i++) {
        const u = data[i];
        const action = u[u.length - 2];
        const {updatedOddMap} = OddsPageUtils
        switch (action) {
          case 0:
            const oid = [
              u[u.length - 1], //EventId
              u[updatedOddMap.PeriodNum], //PeriodNum
              u[updatedOddMap.BetType], //BetType
              u[updatedOddMap.SelectionType], //SelectionType
              u[updatedOddMap.isAltLine] ? 1 : 0, //isAltLine
              u[updatedOddMap.homeSpread] || 0
            ].join('|');
            const a = document.getElementById(oid);
            if (OddsPageUtils.updateOdds(u, a, options)) {
              window.changedOddsWS[oid] = timeMessage
            }
            break;
          case 8:
            OddsPageUtils.updateEventStatus(u)
            break;
          case 9:
            OddsPageUtils.updateTimeEvent(u)
            break;
          case 10:
            OddsPageUtils.updateScore(u)
            break;
          case 13:
            OddsPageUtils.updatePeriodStatus(u, options)
            break;
          default:
            break;
        }
      }
    }
  }

  static generateMoreBetMessage(eventId, eventId01) {
    const moreBetMessage = {
      type: MESSAGES_ODD_PAGE_WS.MORE_BET,
      destination: DESTINATION_WS.ODDS,
      eventId
    }
    if (!_.isNil(eventId01)) {
      moreBetMessage["eventId01"] = eventId01
    }
    return moreBetMessage
  }

  static generateUnMoreBetMessage() {
    return {
      type: MESSAGES_ODD_PAGE_WS.UN_MORE_BET,
      destination: DESTINATION_WS.ODDS
    }
  }

    static renderMoreBet(data, options, marketSecledted) {
        if (!data.e || !data.e[FullEvent.event] || !data.e[FullEvent.event][EventDetail.periods]) {
            return null
        }
      
        let outrightEvents = [], specialsPeriods = [];
        let playerOutrights = [];
        const event = data.e[FullEvent.event]
        const periods = event[EventDetail.periods]
        const firstPeriodsData =  periods[Object.keys(periods)[0]]
        const isRunning = event[EventDetail.running]
        if(firstPeriodsData) {
          outrightEvents = this.convertOutrightEvents({a: firstPeriodsData[1]}, options).map(function(data) {
              const specialEvents = data[OutrightEventMap.specialEvents];
              data[OutrightEventMap.specialEvents] = _.groupBy(specialEvents, e => e[SpecialEventMap.periodNumber]);
              return data;
          });
        }
    
        if (outrightEvents && outrightEvents.length > 0) {
          specialsPeriods = Object.keys(outrightEvents[0].se);
          playerOutrights = outrightEvents.filter(item => 
            item.ocg === "Player Props" 
            || item.ocg === "Goalscorer" 
          );
          outrightEvents = outrightEvents.filter (item => 
            item.ocg !== "Player Props" 
            && item.ocg !== "Goalscorer" 
            );

        }

        let expandedPeriods = []
        let runningPeriod = this.getSpecialRunningPeriods(specialsPeriods, isRunning, options.period)
        if (runningPeriod !== -1) {
        expandedPeriods.push(Number(runningPeriod))
        
        let runningPeriodIdx = specialsPeriods.indexOf(runningPeriod + '')
        let isAddMoreExpandPeriod = (isRunning && runningPeriod != -1) || runningPeriod == 0 // Event is Running OR current expanded period is 0
        if (isAddMoreExpandPeriod && specialsPeriods.length >= runningPeriodIdx + 1) {
            expandedPeriods.push(Number(specialsPeriods[runningPeriodIdx + 1]))
        }
        }
        
        
        // Match/ Fulltime period will always be displayed
        if (expandedPeriods.indexOf(0) == -1) {
            expandedPeriods.push(0)
        }
        const isNewTennis = options.sportId === Constants.TENNIS_ID && window.env.isUseNewTennisLayout;
        const eventId = data.e && data.e[FullEvent.event] ? data.e[FullEvent.event][EventDetail.id] : 0
        let dataRender = {
            moreBets: this.getMoreBetsEvents(data.e),
            startIndex: this.getBetTypeGroup(options) === BetTypeGroup.HDP_OU ? options.marketFilter : 0,
            mtGroup: parseInt(this.getBetTypeGroup(options), 10),
            singleLine: options.oddsMode === OddsMode.Single,
            isParlay: options.mode === Mode.TV ? this.getBetTypeGroup(options) == BetTypeGroup.MIX_PARLAY : options.mode === Mode.PARLAY,
            isParlayMarket: options.mode === Mode.PARLAY_MARKET,
            outrightEvents: outrightEvents,
            playerOutrights: playerOutrights,
            period: parseInt(options.period, 10),
            ot: options.oddsFormat,
            expandedPeriods: expandedPeriods,
            marketSecledted: marketSecledted,
            mode: options.mode,
            allPeriod: options.allPeriod || '',
            isNewTennis: isNewTennis,
            homeAwayLabel: isNewTennis ? HOME_AWAY_LABEL[options.sportId] || HOME_AWAY_LABEL[0] : HOME_AWAY_LABEL[0],
            esportsCode: options.sportId === Constants.ESPORT_ID ? this.getESGameCode(eventId) : '',
            listSportsShowLabel: window.env.listSportsShowLabel || []
          }
          if (options.sportId === Constants.SOCCER_ID) {
            if (data.ce) {
              dataRender.cornersMoreBets = this.getMoreBetsEvents(data.ce);
            }
            if (data.be) {
              dataRender.bookingsMoreBets = this.getMoreBetsEvents(data.be);
            }
            dataRender.minuteMoreBets = this.getMoreBetsEvents(data.e, true);
          }
          dataRender.marketNo = this.countMorebetMarketNo(dataRender, expandedPeriods);
          dataRender.favSel = this.getFavSel(event[EventDetail.id]);
          dataRender.periodsDescription = options.periodsDescription;
        return dataRender.marketNo.allMarket > 0
          ? doTUtils.bindMoreBetsData(dataRender, options)
          : null;
    }

  static renderTennisMoreBet(setsData, gamesData, options, marketSecledted) {
    const firstEvent = setsData && setsData.e ? setsData.e[FullEvent.event] : null;
    const secondEvent = gamesData && gamesData.e ? gamesData.e[FullEvent.event] : null;
    if (!firstEvent && !secondEvent) {
      return null
    }
    let events = [];
    if(firstEvent) {
      events.push(firstEvent)
    }
    if(secondEvent) {
      events.push(secondEvent)
    }
    let outrightEvents = [], specialsPeriods = [];
    let playerOutrights = [];
    const periods = events.reduce(function (pe, e) { return pe.concat(Object.keys(e[8])); }, []);
    const firstPeriodsData = periods[Object.keys(periods)[0]]
    const isRunning = firstEvent && firstEvent[EventDetail.running] ? firstEvent[EventDetail.running] : [];
    if (firstPeriodsData) {
      outrightEvents = this.convertOutrightEvents({ a: firstPeriodsData[1] }, options).map(function (data) {
        const specialEvents = data[OutrightEventMap.specialEvents];
        data[OutrightEventMap.specialEvents] = _.groupBy(specialEvents, e => e[SpecialEventMap.periodNumber]);
        return data;
      });
    }

    if (outrightEvents && outrightEvents.length > 0) {
      specialsPeriods = Object.keys(outrightEvents[0].se);
      playerOutrights = outrightEvents.filter(item =>
        item.ocg === "Player Props"
        || item.ocg === "Goalscorer"
      );
      outrightEvents = outrightEvents.filter(item =>
        item.ocg !== "Player Props"
        && item.ocg !== "Goalscorer"
      );

    }

    let expandedPeriods = []
    let runningPeriod = this.getSpecialRunningPeriods(specialsPeriods, isRunning, options.period)
    if (runningPeriod !== -1) {
      expandedPeriods.push(Number(runningPeriod))

      let runningPeriodIdx = specialsPeriods.indexOf(runningPeriod + '')
      let isAddMoreExpandPeriod = (isRunning && runningPeriod != -1) || runningPeriod == 0 // Event is Running OR current expanded period is 0
      if (isAddMoreExpandPeriod && specialsPeriods.length >= runningPeriodIdx + 1) {
        expandedPeriods.push(Number(specialsPeriods[runningPeriodIdx + 1]))
      }
    }

    const dataEv = setsData && setsData.e ? setsData.e : gamesData.e;
    let dataMoreBets = _.cloneDeep(dataEv);
    dataMoreBets[FullEvent.event] = events;
    const isSetsData = firstEvent && firstEvent[EventDetail.gradingUnit] === GRADING_UNIT_TYPE.SETS;
    const isNewTennis = options.sportId === Constants.TENNIS_ID && window.env.isUseNewTennisLayout;
    let dataRender = {
      moreBets: this.getTennisMoreBetsEvents(dataMoreBets),
      startIndex: this.getBetTypeGroup(options) === BetTypeGroup.HDP_OU ? options.marketFilter : 0,
      mtGroup: parseInt(this.getBetTypeGroup(options), 10),
      singleLine: options.oddsMode === OddsMode.Single,
      isParlay: options.mode === Mode.TV ? this.getBetTypeGroup(options) == BetTypeGroup.MIX_PARLAY : options.mode === Mode.PARLAY,
      isParlayMarket: options.mode === Mode.PARLAY_MARKET,
      outrightEvents: outrightEvents,
      playerOutrights: playerOutrights,
      period: parseInt(options.period, 10),
      betTypePeriod: parseInt(options.betTypePeriod, 10),
      ot: options.oddsFormat,
      expandedPeriods: expandedPeriods,
      marketSecledted: marketSecledted,
      mode: options.mode,
      firstEvent: firstEvent,
      secondEvent: secondEvent,
      favourite: options.favourite,
      isNewTennis: isNewTennis
    }

    dataRender.marketNo = this.countTennisMorebetMarketNo(dataRender, expandedPeriods);
    dataRender.favSel = (firstEvent && isSetsData) && this.getFavSel(firstEvent[EventDetail.id], options.period) 
                        || secondEvent && this.getFavSel(secondEvent[EventDetail.id], options.period);
    dataRender.periodsDescription = options.periodsDescription;
    return dataRender.marketNo.allMarket > 0
      ? doTUtils.bindMoreBetsData(dataRender, options)
      : null;
  }
    
  static loadingMoreBet(element, isLoading) {
    const textLoading =
      `<div class="is-loading">
        <div class="loading-layout">
          <span class="loading-icon">
              <i class="sport-icon icon-soccer fa-spin"></i>
          </span>
        </div>
      </div>
      `;
    return isLoading ? element.html(textLoading) : element.children().remove();
  }
    
    static getFavSel(eventId, period) { 
      let line = '';
      document.querySelectorAll(`.e${eventId}_${period}`).forEach(item => {
        if(item.getElementsByClassName('bookmark').length > 0) {
          line = item;
        }
      });
      const eventUnderDog = period && line ? line : (document.getElementsByClassName(`e${eventId}`) || [])[0];
      const mainLine = document.getElementById(`e${eventId}_0`) || eventUnderDog;
      if (mainLine) {
        const colName = mainLine.getElementsByClassName('col-name');
        if (colName.length > 0) {
          const isNoUnderDog = mainLine.getElementsByClassName('no-underdog').length > 0;
          const favSpans = [...colName[0].getElementsByTagName('span')].filter(span => {
            return ['favSel', 'sel'].includes(span.classList.value);
          });
          return {
            isNoUnderDog: isNoUnderDog, 
            favHome: (favSpans[0] && favSpans[0].classList.value) || '',
            favAway: (favSpans[1] && favSpans[1].classList.value) || ''
          }
        }
      }
      return {
        isNoUnderDog: false, 
        favHome: '',
        favAway: ''
      };
    }

    static getMoreBetsEvents(fullEvent, isMinutes) {
      const copiedFullEvent = JSON.parse(JSON.stringify(fullEvent));
      const periods = copiedFullEvent[FullEvent.event][EventDetail.periods];
      Object.keys(periods)
          .filter(period => isMinutes
            ? !MINUTES_PERIODS.includes(Number(period, 10))
            : MINUTES_PERIODS.includes(Number(period, 10))
          )
          .map(period => delete periods[Number(period, 10)]);
      copiedFullEvent.periods = periods;
      return copiedFullEvent;
    }
   
    static getTennisMoreBetsEvents(fullEvent, isMinutes) {
      const copiedFullEvent = JSON.parse(JSON.stringify(fullEvent));
      const events = copiedFullEvent[FullEvent.event];
      events.forEach(ev => {
        if(ev && ev[EventDetail.periods]) {
          const periods = ev[EventDetail.periods];
          Object.keys(periods)
              .filter(period => isMinutes
                ? !MINUTES_PERIODS.includes(Number(period, 10))
                : MINUTES_PERIODS.includes(Number(period, 10))
              )
              .map(period => delete periods[Number(period, 10)]);
          ev.periods = periods;
        }
       
      })
      copiedFullEvent[FullEvent.event] = events;
      return copiedFullEvent;
    }
   

  static countMorebetMarketNo(dataRender, expandedPeriods) {
      let result = {
          allMarket: 0,
          periods: {},
          teamProps: 0,
          playerProps: 0
      };
      const moreBets = dataRender.moreBets;
      if (moreBets.length > 0) {
        const periods = moreBets[FullEvent.event][EventDetail.periods];
        const optionsPeriod = Object.keys(periods);
        const tennisPeriod = dataRender.period === parseInt(optionsPeriod[0]) ? CommonUtil.getPeriodMoreBet(optionsPeriod, dataRender.allPeriod) : [dataRender.period];
        const periodKeys = dataRender.isNewTennis ? tennisPeriod : optionsPeriod;
        _.forEach(periodKeys, period => {
            const mkCount = {
              ml: this.countMLEvent(dataRender, periods, parseInt(period, 10)),
              ou: periods[period][3] ? periods[period][3].length : 0,
              hdp: periods[period][2] ? periods[period][2].length : 0,
              tt: !dataRender.isNewTennis ? this.countTeamTotalEvent(dataRender, periods, parseInt(period, 10)) : 0
            }; 
            result.periods[period] = mkCount;
            result.allMarket += mkCount.ml + mkCount.hdp + mkCount.ou + mkCount.tt;
        })
      }
      const cornersMoreBets = dataRender.cornersMoreBets;
      if (cornersMoreBets && cornersMoreBets.length > 0) {
        const periods = cornersMoreBets[FullEvent.event][EventDetail.periods];
        const periodKeys = Object.keys(periods);
        result.cornersCount = 0;
        result.cornersPeriods = {};
        _.forEach(periodKeys, period => {
            const mkCount = {
              ml: this.countMLEvent(dataRender, periods, parseInt(period, 10)),
              ou: periods[period][3] ? periods[period][3].length : 0,
              hdp: periods[period][2] ? periods[period][2].length : 0,
              tt: this.countTeamTotalEvent(dataRender, periods, parseInt(period, 10))
            }; 
            result.cornersPeriods[period] = mkCount;
            result.cornersCount += mkCount.ml + mkCount.hdp + mkCount.ou + mkCount.tt;
            result.allMarket += mkCount.ml + mkCount.hdp + mkCount.ou + mkCount.tt;
        })
      }
      const bookingsMoreBets = dataRender.bookingsMoreBets;
      if (bookingsMoreBets && bookingsMoreBets.length > 0) {
        const periods = bookingsMoreBets[FullEvent.event][EventDetail.periods];
        const periodKeys = Object.keys(periods);
        result.bookingsPeriods = {};
        result.bookingsCount = 0;
        _.forEach(periodKeys, period => {
          const mkCount = {
            ml: this.countMLEvent(dataRender, periods, parseInt(period, 10)),
            ou: periods[period][3] ? periods[period][3].length : 0,
            hdp: periods[period][2] ? periods[period][2].length : 0,
            tt: this.countTeamTotalEvent(dataRender, periods, parseInt(period, 10))
          }; 
          result.bookingsPeriods[period] = mkCount;
          result.bookingsCount += mkCount.ml + mkCount.hdp + mkCount.ou + mkCount.tt;
          result.allMarket += mkCount.ml + mkCount.hdp + mkCount.ou + mkCount.tt;
        })
      }
      const minutesMoreBets = dataRender.minuteMoreBets;
      if (minutesMoreBets && minutesMoreBets.length > 0) {
        const minutePeriods = minutesMoreBets[FullEvent.event][EventDetail.periods];
        const minutePeriodKeys = Object.keys(minutesMoreBets[FullEvent.event][EventDetail.periods]);
        const minuteMarkets = {
          ml: {periods: [], totalEvents: 0},
          hdp_ou: {periods: [], totalEvents: 0},
          tt: {periods: [], totalEvents: 0}
        };
        _.forEach(minutePeriodKeys, period => {
          const mkCount = {
            ml: this.countMLEvent(dataRender, minutePeriods, parseInt(period, 10)),
            ou: minutePeriods[period][3] ? minutePeriods[period][3].length : 0,
            hdp: minutePeriods[period][2] ? minutePeriods[period][2].length : 0,
            tt: this.countTeamTotalEvent(dataRender, minutePeriods, parseInt(period, 10))
          }; 
          result.allMarket += mkCount.ml + mkCount.hdp + mkCount.ou + mkCount.tt;
          if (mkCount.ml > 0) {
            minuteMarkets['ml'].periods.push(Number(period, 10));
            minuteMarkets['ml'].totalEvents += mkCount.ml;
          }
          if (mkCount.ou > 0 || mkCount.hdp > 0) {
            minuteMarkets['hdp_ou'].periods.push(Number(period, 10));
            minuteMarkets['hdp_ou'].totalEvents += (mkCount.ou + mkCount.hdp) ;
          }
          if (mkCount.tt > 0) {
            minuteMarkets['tt'].periods.push(Number(period, 10));
            minuteMarkets['tt'].totalEvents += mkCount.tt;
          }
        })
        result.minuteMarkets = minuteMarkets;
      }
      // Count Outright events
      if(!dataRender.isParlay && !dataRender.isParlayMarket && dataRender.outrightEvents.length > 0) {
        _.forEach(dataRender.outrightEvents, item => {
          _.forEach(Object.keys(item.se), period => {
            result.teamProps += item.se[period].length;
          });
        });
        result.allMarket += result.teamProps;
      }
      if(!dataRender.isParlay && !dataRender.isParlayMarket && dataRender.playerOutrights.length > 0) {
        _.forEach(dataRender.playerOutrights, item => {
          _.forEach(Object.keys(item.se), period => {
            result.playerProps += item.se[period].length;
          });
        });
        result.allMarket += result.playerProps;
      }
      return result;
  }

    static countTennisMorebetMarketNo(dataRender, expandedPeriods) {
      let result = {
          allMarket: 0,
          periods: {},
          teamProps: 0,
          playerProps: 0
      };
      const moreBets = dataRender.moreBets;
      const period = dataRender.period;
      if (moreBets.length > 0) {
        const events =  moreBets[FullEvent.event];
        const validEvents = events;
        validEvents.forEach(ev => {
          if(ev) {
            const periods = ev[EventDetail.periods];
            const periodKeys = (dataRender.betTypePeriod > 0 || dataRender.favourite) ? Object.keys(periods) : [period];
            const isUnitSets = ev[EventDetail.gradingUnit] === Constants.UNIT_SET;
            const isUnitGames =  ev[EventDetail.gradingUnit] === Constants.UNIT_GAMES || ev[EventDetail.isGameInTeamName];
            const isUnitParentGame = ev[EventDetail.gradingUnit] === Constants.UNIT_REGULAR || isUnitGames;
            const isUnitParentSet =  ev[EventDetail.gradingUnit] === Constants.UNIT_REGULAR && !ev[EventDetail.isGameInTeamName] || isUnitSets;
            
            periodKeys.forEach(periodNum => {
              let counts = JSON.parse(JSON.stringify(result.periods[periodNum] || TENNIS_COUNT_MORE_BET)) ;
              counts.mlSets += (isUnitParentSet ? this.countMLEvent(dataRender, periods, parseInt(periodNum, 10)) : 0);
              counts.mlGames += (isUnitGames ? this.countMLEvent(dataRender, periods, parseInt(periodNum, 10)) : 0);
              counts.ml += this.countMLEvent(dataRender, periods, parseInt(periodNum, 10));
              counts.ou += periods[periodNum] && periods[periodNum][3] ? periods[periodNum][3].length : 0;
              counts.ouSets += isUnitSets && periods[periodNum] && periods[periodNum][3] ? periods[periodNum][3].length : 0;
              counts.ouGames += isUnitParentGame && periods[periodNum] && periods[periodNum][3] ? periods[periodNum][3].length : 0;
              counts.hdpSets += isUnitSets && periods[periodNum] && periods[periodNum][2] ? periods[periodNum][2].length : 0;
              counts.hdpGames += isUnitParentGame && periods[periodNum] && periods[periodNum][2] ? periods[periodNum][2].length : 0;
              counts.hdp += periods[periodNum] && periods[periodNum][2] ? periods[periodNum][2].length : 0;
              counts.ttSets += (isUnitSets ? this.countTeamTotalEvent(dataRender, periods, parseInt(periodNum, 10)) : 0);
              counts.ttGames += (isUnitParentGame ? this.countTeamTotalEvent(dataRender, periods, parseInt(periodNum, 10)) : 0);
              counts.tt += this.countTeamTotalEvent(dataRender, periods, parseInt(periodNum, 10));
              result.periods[periodNum] = counts;
            });
          }
        });
        const filterPeriod = Object.keys(result.periods) || [];
        filterPeriod.forEach(periodNum => {
          const periodMoreBet = result.periods[periodNum];
          result.allMarket += periodMoreBet.ml + periodMoreBet.hdp + periodMoreBet.ou + periodMoreBet.tt;
        });
      }
      const cornersMoreBets = dataRender.cornersMoreBets;
      if (cornersMoreBets && cornersMoreBets.length > 0) {
        const events =  cornersMoreBets[FullEvent.event];
        const validEvents = events;
        const counts = {
          ml: 0,
          ou: 0,
          hdp:  0,
          tt: 0
        }
        validEvents.forEach(ev => {
          const periods = ev[EventDetail.periods];
          counts.ml +=  this.countMLEvent(dataRender, periods, parseInt(period, 10));
          counts.ou +=  periods[period] && periods[period][3] ? periods[period][3].length : 0;
          counts.hdp +=  periods[period] && periods[period][2] ? periods[period][2].length : 0;
          counts.tt +=  this.countTeamTotalEvent(dataRender, periods, parseInt(period, 10));    
              
        })
        result.cornersCount = 0;
        result.cornersPeriods = {};
        const mkCount = {
          ml: counts.ml,
          ou: counts.ou,
          hdp:  counts.hdp,
          tt: counts.tt
        }; 
        result.cornersPeriods[period] = mkCount;
        result.cornersCount += mkCount.ml + mkCount.hdp + mkCount.ou + mkCount.tt;
        result.allMarket += mkCount.ml + mkCount.hdp + mkCount.ou + mkCount.tt;
       
      }
      const bookingsMoreBets = dataRender.bookingsMoreBets;
      if (bookingsMoreBets && bookingsMoreBets.length > 0) {
        const events =  bookingsMoreBets[FullEvent.event];
        const validEvents = events;
        const counts = {
          ml: 0,
          ou: 0,
          hdp:  0,
          tt: 0
        }
        validEvents.forEach(ev => {
          const periods = ev[EventDetail.periods];
          counts.ml +=  this.countMLEvent(dataRender, periods, parseInt(period, 10));
          counts.ou +=  periods[period] && periods[period][3] ? periods[period][3].length : 0;
          counts.hdp +=  periods[period] && periods[period][2] ? periods[period][2].length : 0;
          counts.tt +=  this.countTeamTotalEvent(dataRender, periods, parseInt(period, 10)); 
        })
        result.bookingsPeriods = {};
          result.bookingsCount = 0;
          const mkCount = {
            ml: counts.ml,
            ou: counts.ou,
            hdp:  counts.hdp,
            tt: counts.tt
          }; 
            result.bookingsPeriods[period] = mkCount;
            result.bookingsCount += mkCount.ml + mkCount.hdp + mkCount.ou + mkCount.tt;
            result.allMarket += mkCount.ml + mkCount.hdp + mkCount.ou + mkCount.tt;
        
      }
      const minutesMoreBets = dataRender.minuteMoreBets;
      if (minutesMoreBets && minutesMoreBets.length > 0) {
        const events =  minutesMoreBets[FullEvent.event];
        const validEvents = events
        const counts = {
          ml: 0,
          ou: 0,
          hdp:  0,
          tt: 0
        }
        validEvents.forEach(ev => {
        const minutePeriods = ev[EventDetail.periods];
        counts.ml += this.countMLEvent(dataRender, minutePeriods, parseInt(period, 10));
        counts.ou +=  minutePeriods[period] && minutePeriods[period][3] ? minutePeriods[period][3].length : 0;
        counts.hdp += minutePeriods[period] && minutePeriods[period][2] ? minutePeriods[period][2].length : 0;
        counts.tt +=  this.countTeamTotalEvent(dataRender, minutePeriods, parseInt(period, 10)); 
         
        })
        const minuteMarkets = {
          ml: {periods: [], totalEvents: 0},
          hdp_ou: {periods: [], totalEvents: 0},
          tt: {periods: [], totalEvents: 0}
        };
        const mkCount = {
          ml: counts.ml,
          ou: counts.ou,
          hdp:  counts.hdp,
          tt: counts.tt
        }; 
        result.allMarket += mkCount.ml + mkCount.hdp + mkCount.ou + mkCount.tt;
        if (mkCount.ml > 0) {
          minuteMarkets['ml'].periods.push(Number(period, 10));
          minuteMarkets['ml'].totalEvents += mkCount.ml;
        }
        if (mkCount.ou > 0 || mkCount.hdp > 0) {
          minuteMarkets['hdp_ou'].periods.push(Number(period, 10));
          minuteMarkets['hdp_ou'].totalEvents += (mkCount.ou + mkCount.hdp) ;
        }
        if (mkCount.tt > 0) {
          minuteMarkets['tt'].periods.push(Number(period, 10));
          minuteMarkets['tt'].totalEvents += mkCount.tt;
        }
       
      result.minuteMarkets = minuteMarkets;
        
        
      }
      // Count Outright events
      if(!dataRender.isParlay && !dataRender.isParlayMarket && dataRender.outrightEvents.length > 0) {
        _.forEach(dataRender.outrightEvents, item => {
          _.forEach(Object.keys(item.se), period => {
            result.teamProps += item.se[period].length;
          });
        });
        result.allMarket += result.teamProps;
      }
      if(!dataRender.isParlay && !dataRender.isParlayMarket && dataRender.playerOutrights.length > 0) {
        _.forEach(dataRender.playerOutrights, item => {
          _.forEach(Object.keys(item.se), period => {
            result.playerProps += item.se[period].length;
          });
        });
        result.allMarket += result.playerProps;
      }
      return result;
  }

    static countMLEvent(data, periodData, periodNum) {
      const isEsport = data.moreBets[0] === 12;
      const isDisplayPeriodSport = CommonUtil.isShowPeriodName(data.moreBets[0]);
      const mkPeriod = data.period;
      const is1x2Type = data.mtGroup === BetTypeGroup.ML_1X2;
      const show1x2 = !is1x2Type && (
        (data.singleLine && data.mtGroup === BetTypeGroup.HDP_OU) ||
        (data.favourite && data.isNewTennis && data.betTypePeriod !== periodNum) ||
        data.mtGroup === BetTypeGroup.TEAM_TOTAL
      );
      const show1x2Period = !is1x2Type && (
        (mkPeriod > 0 && data.mtGroup === BetTypeGroup.HDP_OU) || 
        data.mtGroup === BetTypeGroup.TEAM_TOTAL
      );
      const isLiveCenterMode = data.mode === Mode.LC || data.mode === Mode.TV;
      const isNotSelectedPeriod = periodNum !== mkPeriod;
      const isShowML = show1x2 || (show1x2Period && isNotSelectedPeriod);
      const isNotSecondPeriod = periodNum > 0 && (
        (PERIODS_RIGHT_ODDS_LAYOUT[data.moreBets[0]] || [1])[0] !== periodNum
      );
      const periodsDisplay = CommonUtil.getAllDisplayPeriods(data.moreBets[0]) || [];
      const isExistML = isDisplayPeriodSport && periodsDisplay && periodsDisplay.includes(periodNum) && !is1x2Type;
      const isShow = isLiveCenterMode
        || isShowML
        || (!isEsport && !isExistML && isNotSecondPeriod && isNotSelectedPeriod)
        || (isEsport && (
            (is1x2Type && periodNum > 1) || 
            (periodNum > 3 && isNotSelectedPeriod) ||
            (
              mkPeriod > 0 && isNotSelectedPeriod
            )
          )
        );
      if(isShow && periodData && periodData[periodNum]) {
        return periodData[periodNum][4] ? 1 : 0; 
      }
      return 0;
    }

    static countTeamTotalEvent(data, periodData, periodNum) {
      const showTT = data.mtGroup !== BetTypeGroup.TEAM_TOTAL;
      if (periodData[periodNum] && periodData[periodNum][0]) {
        const lineId = periodData[periodNum][0][2]; 
        if(lineId !== 0 && ((showTT || periodNum > 1) || (!showTT && periodNum === 1))) {
          return periodData[periodNum][0].length > 0 ? 1 : 0;
        }
      }
      return 0;
    }

    static getCorrectScore(data, options) {      
        if (!data.a) return [];        
        var leagueSrt;
        var leagueIds = [];
        var leagues = [];
        if (data.a) {
            // Clone data.a and sort by League Name
            leagueSrt = data.a.slice(0);
            leagueSrt.sort(function (a, b) {
                var leagueA = a.ln.toUpperCase(); // ignore upper and lowercase
                var leagueB = b.ln.toUpperCase(); // ignore upper and lowercase
                if (leagueA < leagueB) {
                    return -1;
                }
                if (leagueA > leagueB) {
                    return 1;
                }
                // names must be equal
                return 0;
            });
            for (let iCount = 0; iCount < data.a.length; iCount++) {
                for (let jCount = 0; jCount < data.a[iCount].se.length; jCount++) {
                    // Filter all invalid contestant line - mean that: Either name OR price is null.
                    data.a[iCount].se[jCount].l = data.a[iCount].se[jCount].l.filter(function (contestantLine) {
                        return contestantLine.n && contestantLine.p;
                    });
                }
            }
            // Filter the Special Event whether there is no ontestant line
            data.a = data.a.filter(function (specialEvent) {
                // Handle for "Correct Score"                        
                if(options && options.isCorrectScore) {
                    return (specialEvent.cg.trim() === 'Correct Score') && (specialEvent.se.length > 0);
                } 
                return  specialEvent.se.length > 0;
            });
            // Sort ContestLine by name on each event
            for (let iCount = 0; iCount < data.a.length; iCount++) {
                for (let jCount = 0; jCount < data.a[iCount].se.length; jCount++) {
                    data.a[iCount].se[jCount].l.sort(function (a, b) {
                        var contestLineA = a.n.toUpperCase(); // ignore upper and lowercase
                        var contestLineB = b.n.toUpperCase(); // ignore upper and lowercase
                        if (contestLineA < contestLineB) {
                            return -1;
                        }
                        if (contestLineA > contestLineB) {
                            return 1;
                        }
                        // names must be equal
                        return 0;
                    });
                }
            }
            // Sort League by League Name
            for (let iCount = 0; iCount < leagueSrt.length; iCount++) {
                //Filter duplicated League by League Id
                if (leagueIds.length === 0 || leagueIds.indexOf(leagueSrt[iCount].li) === -1) {
                    leagueIds.push(leagueSrt[iCount].li);
                    leagues.push([leagueSrt[iCount].li, 0, leagueSrt[iCount].ln]);
                }
            }
        }
        return data.a;
    }
    /**
   * Convert outright events from data
   * @param {*} data 
   */
  static convertOutrightEvents(data, options, searchSportId) {
    if (!data.a) {
      return [];
    }
    var leagueSrt;
    var leagueIds = [];
    var leagues = [];
    if (data.a) {
      // Clone data.a and sort by League Name
      leagueSrt = data.a.slice(0);
      leagueSrt.sort(function (a, b) {
        var leagueA = a.ln.toUpperCase(); // ignore upper and lowercase
        var leagueB = b.ln.toUpperCase(); // ignore upper and lowercase
        if (leagueA < leagueB) {
          return -1;
        }
        if (leagueA > leagueB) {
          return 1;
        }
        // names must be equal
        return 0;
      });

      // Filter the Special Event whether there is no ontestant line
      data.a = data.a.filter(function (specialEvent) {
        // Handle for "Correct Score"                        
        if(options && options.isCorrectScore) {
          return (specialEvent.cg.trim() === 'Correct Score') && (specialEvent.se.length > 0);
        } 
        return  specialEvent.se.length > 0;
      });

      const isEsport = options.mode === Mode.SEARCH
        ? searchSportId !== 12
        : options.sportId !== 12;
      // Sort ContestLine by name on each event
      _.forEach(data.a, (league, i) => {
        const specialEvents = league[OutrightEventMap.specialEvents];
        league.gameCode = isEsport ? CommonUtil.getGameCodeByLeagueName(league[OutrightEventMap.leagueName]) : '';
        const teamNames =  league.levn ? league.levn.split(' vs ') : league.levn;
        _.forEach(specialEvents, (event, j) => {
          const contestantLines = event[SpecialEventMap.contestantLines];
          const eventName = event[SpecialEventMap.specialName];
          const isCorrectScore = _.startsWith(eventName, 'Correct Score');
          if (isCorrectScore) {
            const { winScores, drawScores, loseScores } = this.generateScores(contestantLines, teamNames);
            event[SpecialEventMap.winScores] = winScores;
            event[SpecialEventMap.drawScores] = drawScores;
            event[SpecialEventMap.loseScores] = loseScores;
            event[SpecialEventMap.maxScoreLine] = _.max([winScores.length, drawScores.length, loseScores.length]);
          }
        });
      });
      // Sort League by League Name
      for (let iCount = 0; iCount < leagueSrt.length; iCount++) {
        //Filter duplicated League by League Id
        if (leagueIds.length === 0 || leagueIds.indexOf(leagueSrt[iCount].li) === -1) {
          leagueIds.push(leagueSrt[iCount].li);
          leagues.push([leagueSrt[iCount].li, 0, leagueSrt[iCount].ln]);
        }
      }
    }
    return data.a;
  }

  static generateScores(contestantLines, teamNames) {
    const { WIN, DRAW, LOSE } = CorrectScoreTypes;
    const winScores = [];
    const drawScores = [];
    const loseScores = [];
    _.forEach(contestantLines, line => {
      const status = line[ContestantLineMap.status];
      switch(status) {
        case WIN:
          winScores.push(line);
          break;
        case DRAW:
          drawScores.push(line);
          break;
        case LOSE:
          loseScores.push(line);
          break;
        default:
        break;
      }
    });

    return {
      winScores: winScores,
      drawScores: drawScores,
      loseScores: loseScores,
    };
  }
  
  /**
   * Get Special Running period
   */
  static getSpecialRunningPeriods = (availablePeriods, isRunning, selectedPeriod) => {
    if (!availablePeriods || availablePeriods.length == 0) {
      return -1
    }

    if (!isRunning) {
      return selectedPeriod ? selectedPeriod : availablePeriods[0]
    } else if (availablePeriods.length >= 1) { 
      // If there are more than one period available then the Running period for Live event must be other than 0
      return availablePeriods[0] != 0 ? availablePeriods[0] : availablePeriods[1]
    }

    return availablePeriods[0]
  }

  static updateOutright(path, value){
    if (!this.outright){
      this.outright = {};
    }
    _.set(this.outright, path, value);
  }

  /**
   * Prepare the params to retrieve the out right data for the odds page.
   */
  static buildOutrightParams(options, isAuth) {
    const {
      outright, oddsFormat, ogCache, market, eSports, sportId
    } = options;
    
    const { leagueIds, outrightType } = outright;

    const userPref = _.get(this.outright, `sp${sportId}`);
    const refresh = _.get(this.outright,'refresh');

    let oddSince = 0;
    let fixtureSince = 0;
    if(refresh && typeof userPref !== 'undefined'){
      oddSince = userPref.oddSince;
      fixtureSince = userPref.fixtureSince;
    }

    const params = {
      sportId: sportId,
      oddSince: oddSince,
      fixtureSince: fixtureSince,
      betIds: _.join(leagueIds, ','),
      ot: oddsFormat,
      g: ogCache,
      mk: market,
      ort: outrightType,
      _g: isAuth ? 0 : 1
    }

    if (sportId == E_SPORT_ID ) {
      params.eSportCode = eSports.eSportCode;
      params.betIds =  _.join(eSports.eSportLeagueIds, ',')
    }
    return params;
  }

  static bindOutrightTemplate(data, options) {
    if (data && data.error){
      return '';
    }
    const dataRender = {
      ot: options.oddsFormat,
      spId: _.get(options, 'outright.sportId'),
      expandLeagues: data.expandLeagues || [0],
    };

    if ((data.a && data.a.length > 0) || data.f === null || data.o === null) {
      dataRender.a = data.a;
    }

    dataRender.esportsLogoURL = this.getEsportLogoURL();
    dataRender.isEnableSignUp =window.env.skinName === 'pa';
    return doTUtils.bindData(dataRender, options);
  }

  static renderOutrightOdds(data, options, expandLeagues) {
    const outright = {
      oddSince: data.o,
      fixtureSince: data.f
    };
    this.updateOutright(`sp${_.get(options, 'outright.sportId')}`, outright);
    const dataRender = {
      ...data,
      a: this.convertOutrightEvents(data, options),
      expandLeagues: expandLeagues
    }
    
    return {
      outright: this.bindOutrightTemplate(dataRender, options),
      u: data.u || {}
    };
  }

  static isLiveCenter(mode) {
    return mode === Mode.LC;
  }
  static isLiveTV(mode) {
    return mode === Mode.TV;
  }
  static isStatsPage(mode) {
    return mode === Mode.ST;
  }
  static isVsSports(mode) {
    return mode === Mode.VS_NORMAL || mode === Mode.VS_PARLAY;
  }

  static isOutright(mode) {
    return mode === Mode.OUTRIGHT_MARKET || mode === Mode.OUTRIGHT;
  }

  static isTeaser(mode) {
    return mode === Mode.TEASER_MARKET || mode === Mode.TEASER;
  }
  static isSearchEvents(mode) {
    return mode === Mode.SEARCH;
  }

  static isLeagueIdUrlExisted(leagueIdUrl) {
    return leagueIdUrl && !isNaN(leagueIdUrl);
  }

  static getSportId(options = {}) {
    const { mode, teaser = {} } = options;

    let sportId = options.sportId;
    if (this.isTeaser(mode)) {
      sportId = teaser.sportId || TeaserSports.Basketball;
    }
    
    return sportId;
  }

  static convertToSportIcon(sportId) {
    return SPORTS_ICON(sportId)
  }

  static buildTeaserParams(options, isAuth) {
    const { oddsFormat, leagueIds, teaser, timeFilter = 0, order } = options;
    const { date, sportId, typeId, point } = teaser;

    return {
      c:  'Others',
      d:  date || '',
      lg:  _.join(leagueIds, ','),
      m:  0,
      o:  order === EventOrder.League ? 1 : 0,
      ot: oddsFormat,
      p:  point,
      sp: sportId,
      tt: typeId,
      tm: timeFilter,
      _g: isAuth ? 0 : 1
    }
  }

  static getAvailableSport(filter, teaserSports, teaserTypes) {
    let availableSport = {};
    let availableTypes = {};
    if (!_.isEmpty(teaserSports)) {
      let teaserSport = _.find(teaserSports, sport => sport.id === filter.sportId && sport.isAvailable);
      if (!teaserSport) {
        teaserSport =  _.find(teaserSports, sport => sport.isAvailable) || {};
      }
      const { isAvailable, tt } = teaserSport;

      if (isAvailable) {
        const types = teaserTypes.map(type => {
          return tt.find(t => t.id === type[0] && t.name === type[1]) || {};
        });
        const availableTeaserType = _.find(types, type => type.isAvailable);
        const availablePoints = [];
        if(availableTeaserType && availableTeaserType.d) {
          availableTeaserType.d.forEach(date => {
            if(date && date.availableInPoints) {
              date.availableInPoints.forEach(point => availablePoints.push(point))
            }
          });
        }
        if (availableTeaserType) {
          const { id } = availableTeaserType;
          availableSport = {
            sportId: teaserSport.id,
            typeId: id,
            point: availablePoints[0],
          }
          availableTypes = types;
        }
      }
    }
    return {
      availableSport,
      availableTypes
    };
  }

  static convertTeaserTypes(teaserTypes) {
    return _.map(teaserTypes, type => {
      return {
        id: type[TeaserType.id],
        name: type[TeaserType.name],
        points: type[TeaserType.points],
      }
    });
  }

  static convertTeaserResponse(response = {}, filter = {}) {
    const teaserDates = _.get(response, 'd');
    const teaserEvents =  _.get(response, 'n[0]', []);
    const convertTeaserEvents = OddsDataAdapter.convertTeaserDataToEvents(teaserEvents,filter);
    
    const teaser = {
      teaserDates: _.isEmpty(teaserDates) ? [DEFAULT_DATES[0]] : teaserDates,
      teaserLeagues: _.get(teaserEvents, '[2]', []),
      teaserEvents: convertTeaserEvents || [],
    };
    
    let teaserTypes =  _.get(response, 'tt', []);
    let sportId =  _.get(teaserEvents, '[0]')
    const teaserSports =  _.get(response, 'op.ts', []);
    if (!_.isEmpty(teaserSports)) {
      const availableTeaser = this.getAvailableSport(filter, teaserSports, teaserTypes);
      const { availableSport, availableTypes } = availableTeaser;
      sportId = availableSport.sportId;
      teaser.availableSport = availableSport;
      teaserTypes = availableTypes;
    } else {
      teaserTypes = this.convertTeaserTypes(teaserTypes);
    }

    teaser.teaserTypes = teaserTypes;
    teaser.sportId = sportId;

    return teaser;
  }

  static convertEventDetails(event = {}) {
    const result = {};

    if (!_.isEmpty(event)) {
      _.forEach(eventMap, (value, key) => {
        result[key] = event[value];
      });
    }

    return result;
  }

  static getESGameCode(eventId) {
    // get es code by DOM
    const btnShowMore = $('#more_' + eventId)
    const leagueNameSplit = (btnShowMore.data("league-name") || "").split('-');
    return leagueNameSplit[0].replaceAll(" ", "").toLowerCase()
  }

  static standardizeEventsParams(options) {
    return Object.keys(standardizeEventParamsMap).reduce((rs, key) => {
      rs[key] = !_.isNil(options[key]) ? options[key] : (standardizeEventParamsMap[key]);
      return rs;
    }, {});
  }

  static getOddsContainerType = (oddsContainerClass) => {
    if (!oddsContainerClass) return;

    // Check for live odds first
    if (oddsContainerClass.includes("odds-container-live")) {
      return ODDS_CONTAINER_TYPE.LIVE;
    }

    // Check for specific types based on class names
    const type = oddsContainerClass.split(" ").slice(1).join(" "); // [ "highlight", "early", "today"]
    return ODDS_CONTAINER_TYPE[type.toUpperCase()];
  }
  
}



// WEBPACK FOOTER //
// ./src/app/components/CompactView/OddsPageComponent/OddsPageUtils.js